export function getClientApiDomain() {
  return typeof window !== 'undefined' && window?.inlineConfig?.api;
}

export const fetchClient: typeof fetch = (...args) => {
  return fetch(...args);
};
